import React from "react";
import { Link } from "../Router";
import { forceTrailingSlash } from "../../util/urlTransforms"

export default ({ categories = [], allSelectedText, selectedFilter, slug }) =>
    <div className="o-link-list">
        <Link
            to={ forceTrailingSlash( slug ) }
            className={ `o-link-list__item${ selectedFilter ? "" : " o-link-list__item--active" }` }
        >
            { allSelectedText }
        </Link>
        { categories.map((category, index) =>
            <Link
                to={ slug + "?category=" + encodeURIComponent(category) }
                key={ index }
                className={ `o-link-list__item${ category === selectedFilter ? " o-link-list__item--active" : "" }` }
            >
                { category }
            </Link>
        ) }
    </div>;
